// components/SchoolOfManagementHero.jsx
"use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";

export default function SchoolOfManagementHero() {
  const videoRef = useRef(null);
  const [isVideoReady, setIsVideoReady] = useState(false);

  const handleVideoLoaded = () => {
    console.log("onLoadedData fired");

    setIsVideoReady(true);

    const video = videoRef.current;
    if (video && video.paused) {
      video
        .play()
        .then(() => {
          console.log("Video playing");
        })
        .catch((err) => {
          console.error("Autoplay failed:", err);
        });
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // If the video has already loaded before React attaches the handler
    if (video.readyState >= 3) {
      handleVideoLoaded();
    }
  }, []);

  return (
    <section className="relative w-full">
      {/* Background media */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        {/* Fallback image shown until video is ready */}
        {!isVideoReady && (
          <Image
            src="https://cdn.msu.edu.in/career_bg_c2a525719e.png"
            alt="School of Management & Commerce campus"
            fill
            priority
            className="object-cover"
          />
        )}

        {/* Background video */}
        <video
          ref={videoRef}
          className={`h-full w-full object-cover transition-opacity duration-700 ${
            isVideoReady ? "opacity-100" : "opacity-0"
          }`}
          src="https://cdn.msu.edu.in/career_bg_34051d35d1.mp4"
          muted
          loop
          playsInline
          preload="auto"
          controls={false}
          onLoadedData={handleVideoLoaded}
          onError={(e) => {
            console.error("Video error:", e);
          }}
        />

        {/* Dark overlay */}
        <div className="pointer-events-none absolute inset-0 bg-black/40" />
      </div>

      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        <div className="flex min-h-[320px] md:min-h-[420px] lg:min-h-[480px] items-center">
          <div className="w-full py-10 md:py-16 lg:py-20">
            <div className="max-w-xl">
              <p className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight">
                CAREER AT MSU
              </p>
              <p className="font-medium text-white leading-tight">
                An Enriching Atmosphere of Collective Growth
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* View video CTA (bottom-right) */}
      <div className="pointer-events-none absolute inset-x-0 bottom-6">
        <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
          <div className="flex justify-end">
            <button
              type="button"
              className="pointer-events-auto inline-flex items-center gap-2 text-[11px] sm:text-xs md:text-sm font-semibold tracking-[0.18em] uppercase text-white/90 hover:text-white"
            >
              View Video
              <span className="inline-block">
                <svg
                  className="h-3 w-3 md:h-4 md:w-4"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="9"
                    cy="9"
                    r="8"
                    stroke="currentColor"
                    strokeWidth="1.4"
                  />
                  <path d="M7.2 6.4v5.2L11.2 9 7.2 6.4Z" fill="currentColor" />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
